// Korona Tours&Travel — translations (HU / RU)
import {
  Mountain,
  Building2,
  Users,
  Compass,
  ShieldCheck,
  Sparkles,
  UsersRound,
  Gem,
  Settings2,
} from "lucide-react";

const TRIP_IMG = {
  budapest: "https://images.pexels.com/photos/18806130/pexels-photo-18806130.jpeg?auto=compress&cs=tinysrgb&w=1600",
  heviz: "https://images.unsplash.com/photo-1705781451837-83a80808190a?auto=format&fit=crop&w=1600&q=70",
  tihany: "https://images.pexels.com/photos/15227825/pexels-photo-15227825.jpeg?auto=compress&cs=tinysrgb&w=1600",
  festetics: "https://images.pexels.com/photos/14738310/pexels-photo-14738310.jpeg?auto=compress&cs=tinysrgb&w=1600",
  sumeg: "https://images.pexels.com/photos/8954938/pexels-photo-8954938.jpeg?auto=compress&cs=tinysrgb&w=1600",
  tihanyPort: "https://images.pexels.com/photos/15227828/pexels-photo-15227828.jpeg?auto=compress&cs=tinysrgb&w=1600",
  // Hungarikum images
  puli: "https://images.pexels.com/photos/37575692/pexels-photo-37575692.jpeg?auto=compress&cs=tinysrgb&w=1600",
  paprika: "https://images.pexels.com/photos/13073426/pexels-photo-13073426.jpeg?auto=compress&cs=tinysrgb&w=1600",
  gulyas: "https://images.pexels.com/photos/31189384/pexels-photo-31189384.jpeg?auto=compress&cs=tinysrgb&w=1600",
  rubik: "https://images.pexels.com/photos/2121804/pexels-photo-2121804.jpeg?auto=compress&cs=tinysrgb&w=1600",
  tokaj: "https://images.pexels.com/photos/29202989/pexels-photo-29202989.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

const WHY_ICONS = [Compass, ShieldCheck, Sparkles, UsersRound, Gem, Settings2];

export const HU = {
  meta: { code: "hu", label: "Magyar", short: "HU" },
  nav: {
    links: [
      { href: "#fooldal", label: "Főoldal" },
      { href: "#kirandulasok", label: "Kirándulások" },
      { href: "#transzfer", label: "Transzfer" },
      { href: "#rolunk", label: "Rólunk" },
      { href: "#velemenyek", label: "Vélemények" },
      { href: "#kapcsolat", label: "Kapcsolat" },
    ],
    brand: "Korona",
    brandSub: "Tours & Travel",
    cta: "Ajánlatot kérek",
    menuAria: "Menü",
  },
  hero: {
    eyebrow: "✦ Korona Tours & Travel · Hévíz, Magyarország",
    titleA: "Fedezd fel Magyarországot a",
    titleB: "Korona Tourssal",
    subtitle:
      "Prémium hazai kirándulások, gondosan szervezett utazások és felejthetetlen magyar élmények — minden részlet a tiéd.",
    ctaTrips: "Kirándulások megtekintése",
    ctaQuote: "Ajánlatot kérek",
    hqLabel: "Székhely",
    hqValue: "Hévíz — a magyar gyógyvíz fővárosa",
  },
  stats: [
    { value: "500+", label: "Elégedett utazó", icon: Users },
    { value: "40+", label: "Szervezett kirándulás", icon: Mountain },
    { value: "100%", label: "Egyedi programtervezés", icon: Building2 },
    { value: "★ 4.9", label: "Megbízható idegenvezetők", icon: Building2 },
  ],
  trips: {
    eyebrow: "✦ Kiemelt utak",
    titleA: "Magyarország a Korona által —",
    titleB: "kifinomult útvonalak",
    intro:
      "Egy nap a környéken, vagy egy hosszabb körút az országban? Bármi jut eszedbe, írj nyugodtan — és kitaláljuk együtt.",
    cityHeader: "Városnézések",
    cityCount: "06 ÚTI CÉL",
    durationOne: "1 nap",
    cityTours: [
      { id: "budapest", name: "Budapest", subtitle: "A főváros prémium kulturális élményútja" },
      { id: "pecs", name: "Pécs", subtitle: "Mediterrán hangulat és román-kori örökség" },
      { id: "sopron", name: "Sopron", subtitle: "Hűségváros, Lővér-erdő, Tűztorony" },
      { id: "tapolca", name: "Tapolca", subtitle: "A földalatti tavak titokzatos világa" },
      { id: "veszprem-herend", name: "Veszprém – Herend", subtitle: "A királynék városa és a porcelán kincsei" },
      { id: "fehervar-siofok", name: "Székesfehérvár – Siófok", subtitle: "A koronázóváros és a Balaton fővárosa" },
    ],
    specialHeader: "Különleges programok",
    specialCount: "02 ÉLMÉNY",
    specialCta: "Részletek & foglalás",
    specials: [
      {
        id: "sumeg",
        name: "Sümeg",
        subtitle: "Várjátékok",
        description:
          "A legépebben fennmaradt magyar középkori vár — lovagi torna, sólyom-bemutató és középkori lakoma az árnyékában.",
        tag: "Élményprogram",
        image: TRIP_IMG.sumeg,
      },
      {
        id: "keszthely",
        name: "Keszthely",
        subtitle: "Festetics-kastély · Hajózás a Balatonon",
        description:
          "A magyar Versailles — barokk pompa, kastélykert, majd egy elegáns hajósétány a Balaton ezüstös vizén.",
        tag: "Kastély & hajó",
        image: TRIP_IMG.festetics,
      },
    ],
    transferBannerEyebrow: "Transzfer lehetőség",
    transferBannerText:
      "Indulás Budapestről és Bécsből — prémium szedánnal vagy minivannal, akár szállodáig.",
    transferBannerCta: "Transzfer részletei",
  },
  transfer: {
    eyebrow: "✦ Transzfer szolgáltatás",
    titleA: "Kényelmes indulás —",
    titleB: "a küszöbödtől",
    intro:
      "Felveszünk Budapesten a szállodádtól, vagy Bécsben a reptérről. Csak a poggyászodra figyelj — minden mást elintézünk.",
    routeLabel: "Útvonal",
    carLabel: "Jármű",
    durationLabel: "Időtartam",
    arrival: "Hévíz",
    routes: [
      {
        from: "Budapest",
        detail: "M7 autópálya · prémium minivan",
        duration: "~ 1 ó 50 perc",
        note: "Belvárosi szállodáktól és Liszt Ferenc reptérről",
      },
      {
        from: "Bécs",
        detail: "Schwechat reptér · prémium szedán / van",
        duration: "~ 2 ó 30 perc",
        note: "Repülőtér és belváros, igény szerint",
      },
    ],
    cta: "Időpont egyeztetése",
    footer:
      "Csoportos, családi vagy reptéri pickup — minden formátumra van megoldásunk. Csak írd meg, hány fő és mikor.",
    footerCta: "Transzfer ajánlat",
  },
  smart: {
    eyebrow: "✦ Magyarország nevezetességei",
    titleA: "Hazai kincsek,",
    titleB: "királyi élményekkel",
    label: "Magyar hungarikumok",
    landmarks: [
      {
        name: "Hévízi-tó",
        region: "Hungarikum · Gyógyvíz",
        description:
          "A világ legnagyobb biológiailag aktív gyógytava — Hévíz büszkesége, és a Korona Tours&Travel székhelye.",
        image: TRIP_IMG.heviz,
      },
      {
        name: "Puli kutya",
        region: "Hungarikum · Pásztorkutya",
        description:
          "Az ezeréves magyar pásztorkutya, jellegzetes raszta-szőrzettel — élő nemzeti kincsünk.",
        image: TRIP_IMG.puli,
      },
      {
        name: "Magyar paprika",
        region: "Hungarikum · Fűszer",
        description:
          "A Kalocsai és Szegedi piros arany — a magyar konyha lelke, naptól érlelt íz és illat.",
        image: TRIP_IMG.paprika,
      },
      {
        name: "Gulyásleves",
        region: "Hungarikum · Bográcsétel",
        description:
          "A pásztorok eredeti receptje: lassú tűz, marhahús, paprika és puszta-illat egy bográcsban.",
        image: TRIP_IMG.gulyas,
      },
      {
        name: "Rubik-kocka",
        region: "Hungarikum · Találmány",
        description:
          "Rubik Ernő 1974-es alkotása — a világ legkedveltebb logikai játéka, magyar zsenialitás kockába öntve.",
        image: TRIP_IMG.rubik,
      },
      {
        name: "Tokaji aszú",
        region: "Hungarikum · Borvidék",
        description:
          "„A királyok bora, borok királya” — egy korty napsugár a Tokaj-Hegyaljáról, évszázados tradícióval.",
        image: TRIP_IMG.tokaj,
      },
    ],
    weatherLabel: "Időjárás",
    weatherCity: "Budapest",
    weatherTemp: 18,
    weatherDesc: "Napos",
    weatherToday: "Mai aktuális hőmérséklet",
    forecast: [
      { d: "Hétfő", t: "20°" },
      { d: "Kedd", t: "19°" },
      { d: "Szerda", t: "17°" },
    ],
    contactEyebrow: "✦ Gyors kapcsolat",
    contactTitle: "Beszéljünk az úti élményedről",
    contactSub:
      "Hívj minket, vagy kérj visszahívást — bármilyen úton elérsz.",
    phoneCta: "+36 30 627 8654",
    callbackCta: "Visszahívást kérek",
    quoteCta: "Ajánlatot kérek",
  },
  why: {
    eyebrow: "✦ Miért minket válassz",
    titleA: "Miért a",
    titleB: "Korona Tours & Travel?",
    intro:
      "Nem foglalós oldal vagyunk. Egy kis prémium csapat, ahol minden utadon személyesen ügyelünk a részletekre.",
    items: [
      { title: "Gondosan megtervezett útvonalak", text: "Minden megálló, minden étkezés, minden élmény — kurátorként összeállítva." },
      { title: "Kényelmes, biztonságos szervezés", text: "Ellenőrzött partnerek, prémium közlekedés és 24/7 helyi támogatás." },
      { title: "Prémium ügyfélélmény", text: "Személyes utazási tanácsadó az első üzenettől az utolsó pillanatig." },
      { title: "Egyedi csoportos ajánlatok", text: "Cégeknek, baráti társaságoknak és iskoláknak teljes körű szervezés." },
      { title: "Helyi élmények és rejtett látnivalók", text: "Olyan magyar helyek, amiket egy átlagos útikönyvben nem találsz meg." },
      { title: "Rugalmas programtervezés", text: "Az igényeidre szabott útvonal, akár a foglalás után is." },
    ],
  },
  intro: {
    eyebrow: "✦ A márkáról",
    titleA: "Az utazás",
    titleEm: "nem program",
    titleB: "— emlék.",
    body: "A Korona Tours&Travel célja, hogy az utazás ne csak program legyen, hanem emlék. Olyan kirándulásokat szervezünk, ahol minden részlet számít: az útvonal, a hangulat, a kényelem és az élmény.",
    pillar1Top: "Egyedi",
    pillar1Bot: "útvonalterv",
    pillar2Top: "Rejtett",
    pillar2Bot: "helyi élmények",
    badgeTop: "Székhely",
    badgeBot: "Hévíz, Magyarország",
  },
  reviews: {
    eyebrow: "✦ Vélemények",
    titleA: "Amit utazóink",
    titleB: "elmondtak",
    prevAria: "Előző vélemény",
    nextAria: "Következő vélemény",
    items: [
      {
        name: "Kovács Eszter",
        role: "Budapest",
        quote: "Minden tökéletesen meg volt szervezve. Nem kellett semmivel foglalkoznunk, csak élvezni az utazást.",
      },
      {
        name: "Szabó Márton",
        role: "Cégvezető, Debrecen",
        quote: "A program különleges volt, nem a szokásos turistaútvonalakat kaptuk. Igazi élmény volt a csapatomnak.",
      },
      {
        name: "Nagy Katalin",
        role: "Pécs",
        quote: "Elegáns, pontos, megbízható szervezés. Legközelebb is velük utazunk — ehhez nem fér kétség.",
      },
      {
        name: "Horváth Péter",
        role: "Szeged",
        quote: "A részletekre figyelnek, és pont olyan utat kaptam, amilyenről álmodtam. Köszönöm a Korona csapatának.",
      },
    ],
  },
  contact: {
    eyebrow: "✦ Kapcsolat",
    titleA: "Készen állsz a",
    titleB: "következő élményre?",
    intro:
      "Válaszd a számodra legkényelmesebb kapcsolatfelvételi módot — egy személyes utazási tanácsadó áll rendelkezésedre az első üzenettől kezdve.",
    open: "Megnyitás",
    channels: {
      phone: { label: "Telefon", value: "+36 30 627 8654", detail: "Hívj bátran — közvetlen vonal" },
      email: { label: "E-mail", value: "korona.tours555@gmail.com", detail: "Részletes ajánlatkérés, csoportos megkeresés" },
      office: { label: "Székhely", value: "Hévíz, Rákóczi utca 7", detail: "Személyes konzultáció előzetes egyeztetéssel" },
    },
    closing: "„Az utazás nem program — emlék. Mi azon dolgozunk, hogy a tiéd felejthetetlen legyen.\"",
    closingSign: "Korona Tours & Travel · Hévíz",
    mapEyebrow: "✦ Hol talál minket",
    mapTitle: "Találkozzunk Hévízen",
    mapSub: "Irodánk a város szívében, a gyógytótól és a Festetics-kastélytól pár percre.",
    mapAddress: "Hévíz, Rákóczi utca 7",
    mapCta: "Megnyitás Google Maps-en",
  },
  footer: {
    about:
      "Prémium magyarországi kirándulások és gondosan szervezett utazások. Minden részlet a tiéd — neked csak élvezned kell.",
    menu: "Menü",
    contact: "Kapcsolat",
    addr: "Hévíz, Magyarország",
    rights: "Minden jog fenntartva.",
    legal: ["Adatvédelem", "ÁSZF", "Süti tájékoztató"],
    links: [
      { href: "#fooldal", label: "Főoldal" },
      { href: "#kirandulasok", label: "Kirándulások" },
      { href: "#transzfer", label: "Transzfer" },
      { href: "#rolunk", label: "Rólunk" },
      { href: "#velemenyek", label: "Vélemények" },
      { href: "#kapcsolat", label: "Kapcsolat" },
    ],
  },
  toast: {
    callback: {
      title: "Visszahívást rögzítettük",
      desc: "Hamarosan keresünk telefonon — addig is megnézheted a részleteket.",
    },
  },
};

export const RU = {
  meta: { code: "ru", label: "Русский", short: "RU" },
  nav: {
    links: [
      { href: "#fooldal", label: "Главная" },
      { href: "#kirandulasok", label: "Экскурсии" },
      { href: "#transzfer", label: "Трансфер" },
      { href: "#rolunk", label: "О нас" },
      { href: "#velemenyek", label: "Отзывы" },
      { href: "#kapcsolat", label: "Контакты" },
    ],
    brand: "Korona",
    brandSub: "Tours & Travel",
    cta: "Запросить предложение",
    menuAria: "Меню",
  },
  hero: {
    eyebrow: "✦ Korona Tours & Travel · Хевиз, Венгрия",
    titleA: "Откройте Венгрию с",
    titleB: "Korona Tours",
    subtitle:
      "Премиальные экскурсии по Венгрии, тщательно организованные путешествия и незабываемые впечатления — каждая деталь продумана для вас.",
    ctaTrips: "Посмотреть экскурсии",
    ctaQuote: "Запросить предложение",
    hqLabel: "Главный офис",
    hqValue: "Хевиз — столица венгерских термальных вод",
  },
  stats: [
    { value: "500+", label: "Довольных путешественников", icon: Users },
    { value: "40+", label: "Организованных экскурсий", icon: Mountain },
    { value: "100%", label: "Индивидуальное планирование", icon: Building2 },
    { value: "★ 4.9", label: "Надёжные гиды", icon: Building2 },
  ],
  trips: {
    eyebrow: "✦ Избранные маршруты",
    titleA: "Венгрия от Korona —",
    titleB: "изысканные маршруты",
    intro:
      "День рядом или путешествие по стране? Что бы вы ни задумали, напишите нам — придумаем вместе.",
    cityHeader: "Городские туры",
    cityCount: "06 НАПРАВЛЕНИЙ",
    durationOne: "1 день",
    cityTours: [
      { id: "budapest", name: "Будапешт", subtitle: "Премиальный культурный маршрут столицы" },
      { id: "pecs", name: "Печ", subtitle: "Средиземноморская атмосфера и романское наследие" },
      { id: "sopron", name: "Шопрон", subtitle: "Город верности, лес Лёвер, Пожарная башня" },
      { id: "tapolca", name: "Тапольца", subtitle: "Таинственный мир подземных озёр" },
      { id: "veszprem-herend", name: "Веспрем – Херенд", subtitle: "Город королев и сокровища фарфора" },
      { id: "fehervar-siofok", name: "Секешфехервар – Шиофок", subtitle: "Город коронации и столица Балатона" },
    ],
    specialHeader: "Особые программы",
    specialCount: "02 ВПЕЧАТЛЕНИЯ",
    specialCta: "Подробности и бронирование",
    specials: [
      {
        id: "sumeg",
        name: "Шюмег",
        subtitle: "Рыцарские турниры",
        description:
          "Самый сохранившийся венгерский средневековый замок — рыцарский турнир, выступление с соколами и средневековый пир в его тени.",
        tag: "Программа впечатлений",
        image: TRIP_IMG.sumeg,
      },
      {
        id: "keszthely",
        name: "Кестхей",
        subtitle: "Дворец Фештетич · Прогулка по Балатону",
        description:
          "Венгерский Версаль — барочная роскошь, дворцовый парк, затем элегантная прогулка по серебристым водам Балатона.",
        tag: "Дворец и яхта",
        image: TRIP_IMG.festetics,
      },
    ],
    transferBannerEyebrow: "Услуга трансфера",
    transferBannerText:
      "Отправление из Будапешта и Вены — премиальный седан или минивэн, прямо до отеля.",
    transferBannerCta: "Подробности о трансфере",
  },
  transfer: {
    eyebrow: "✦ Услуга трансфера",
    titleA: "Комфортный выезд —",
    titleB: "от вашего порога",
    intro:
      "Заберём вас из отеля в Будапеште или из аэропорта в Вене. Заботьтесь только о багаже — всё остальное мы организуем.",
    routeLabel: "Маршрут",
    carLabel: "Автомобиль",
    durationLabel: "Длительность",
    arrival: "Хевиз",
    routes: [
      {
        from: "Будапешт",
        detail: "Трасса M7 · премиум-минивэн",
        duration: "~ 1 ч 50 мин",
        note: "Из центральных отелей и аэропорта им. Ференца Листа",
      },
      {
        from: "Вена",
        detail: "Аэропорт Швехат · премиум-седан / вэн",
        duration: "~ 2 ч 30 мин",
        note: "Аэропорт и центр города, по запросу",
      },
    ],
    cta: "Согласовать время",
    footer:
      "Групповой, семейный или из аэропорта — у нас есть решение для любого формата. Напишите, сколько человек и когда.",
    footerCta: "Запрос на трансфер",
  },
  smart: {
    eyebrow: "✦ Достопримечательности Венгрии",
    titleA: "Сокровища Венгрии,",
    titleB: "с королевскими впечатлениями",
    label: "Венгерские хунгарикумы",
    landmarks: [
      {
        name: "Озеро Хевиз",
        region: "Хунгарикум · Термальные воды",
        description:
          "Крупнейшее в мире биологически активное термальное озеро — гордость Хевиза и головной офис Korona Tours&Travel.",
        image: TRIP_IMG.heviz,
      },
      {
        name: "Пули",
        region: "Хунгарикум · Овчарка",
        description:
          "Тысячелетняя венгерская пастушья собака с характерной шерстью-«дредами» — живое национальное достояние.",
        image: TRIP_IMG.puli,
      },
      {
        name: "Венгерская паприка",
        region: "Хунгарикум · Специя",
        description:
          "«Красное золото» из Калочи и Сегеда — душа венгерской кухни, вкус и аромат, созданные солнцем.",
        image: TRIP_IMG.paprika,
      },
      {
        name: "Гуляш",
        region: "Хунгарикум · Блюдо в котелке",
        description:
          "Оригинальный рецепт пастухов: медленный огонь, говядина, паприка и аромат степи в одном котелке.",
        image: TRIP_IMG.gulyas,
      },
      {
        name: "Кубик Рубика",
        region: "Хунгарикум · Изобретение",
        description:
          "Творение Эрнё Рубика 1974 года — самая популярная в мире логическая головоломка, венгерская гениальность в кубике.",
        image: TRIP_IMG.rubik,
      },
      {
        name: "Токайское асу",
        region: "Хунгарикум · Винодельческий регион",
        description:
          "„Вино королей, король вин\" — глоток солнца с Токай-Хедьальи, с многовековой традицией.",
        image: TRIP_IMG.tokaj,
      },
    ],
    weatherLabel: "Погода",
    weatherCity: "Будапешт",
    weatherTemp: 18,
    weatherDesc: "Солнечно",
    weatherToday: "Сегодняшняя температура",
    forecast: [
      { d: "Пн", t: "20°" },
      { d: "Вт", t: "19°" },
      { d: "Ср", t: "17°" },
    ],
    contactEyebrow: "✦ Быстрая связь",
    contactTitle: "Поговорим о вашем путешествии",
    contactSub: "Позвоните или попросите перезвонить — любым удобным способом.",
    phoneCta: "+36 30 627 8654",
    callbackCta: "Запросить обратный звонок",
    quoteCta: "Запросить предложение",
  },
  why: {
    eyebrow: "✦ Почему выбрать нас",
    titleA: "Почему",
    titleB: "Korona Tours & Travel?",
    intro:
      "Мы не сайт бронирования. Маленькая премиальная команда, где о каждой детали вашего путешествия мы заботимся лично.",
    items: [
      { title: "Тщательно спланированные маршруты", text: "Каждая остановка, каждый приём пищи, каждое впечатление — собрано как кураторами." },
      { title: "Удобная и безопасная организация", text: "Проверенные партнёры, премиальный транспорт и поддержка 24/7." },
      { title: "Премиальный клиентский опыт", text: "Личный туристический консультант с первого сообщения до последнего момента." },
      { title: "Индивидуальные групповые предложения", text: "Полная организация для компаний, друзей и школ." },
      { title: "Местные впечатления и скрытые места", text: "Венгерские места, которых нет в обычных путеводителях." },
      { title: "Гибкое планирование", text: "Маршрут под ваши пожелания — даже после бронирования." },
    ],
  },
  intro: {
    eyebrow: "✦ О бренде",
    titleA: "Путешествие —",
    titleEm: "не программа",
    titleB: ", а воспоминание.",
    body: "Цель Korona Tours&Travel в том, чтобы путешествие стало не просто программой, а воспоминанием. Мы организуем такие экскурсии, где важна каждая деталь: маршрут, атмосфера, комфорт и впечатления.",
    pillar1Top: "Уникальный",
    pillar1Bot: "маршрут",
    pillar2Top: "Скрытые",
    pillar2Bot: "местные впечатления",
    badgeTop: "Главный офис",
    badgeBot: "Хевиз, Венгрия",
  },
  reviews: {
    eyebrow: "✦ Отзывы",
    titleA: "Что рассказали",
    titleB: "наши путешественники",
    prevAria: "Предыдущий отзыв",
    nextAria: "Следующий отзыв",
    items: [
      {
        name: "Эстер Ковач",
        role: "Будапешт",
        quote: "Всё было организовано идеально. Нам не пришлось ни о чём заботиться — только наслаждаться путешествием.",
      },
      {
        name: "Мартон Сабо",
        role: "Руководитель, Дебрецен",
        quote: "Программа была особенной — мы не получили обычных туристических маршрутов. Настоящее впечатление для моей команды.",
      },
      {
        name: "Каталин Надь",
        role: "Печ",
        quote: "Элегантная, точная и надёжная организация. В следующий раз поедем снова с ними — это вне сомнений.",
      },
      {
        name: "Петер Хорват",
        role: "Сегед",
        quote: "Они уделяют внимание деталям, и я получил именно тот маршрут, о котором мечтал. Спасибо команде Korona.",
      },
    ],
  },
  contact: {
    eyebrow: "✦ Контакты",
    titleA: "Готовы к",
    titleB: "следующему впечатлению?",
    intro:
      "Выберите удобный для вас способ связи — личный туристический консультант будет к вашим услугам с первого сообщения.",
    open: "Открыть",
    channels: {
      phone: { label: "Телефон", value: "+36 30 627 8654", detail: "Звоните смело — прямая линия" },
      email: { label: "E-mail", value: "korona.tours555@gmail.com", detail: "Детальный запрос, групповые обращения" },
      office: { label: "Главный офис", value: "Хевиз, ул. Ракоци 7", detail: "Личная консультация по предварительной договорённости" },
    },
    closing: "„Путешествие — не программа, а воспоминание. Мы работаем над тем, чтобы ваше стало незабываемым.\"",
    closingSign: "Korona Tours & Travel · Хевиз",
    mapEyebrow: "✦ Где нас найти",
    mapTitle: "Встретимся в Хевизе",
    mapSub: "Наш офис в самом центре города — в нескольких минутах от термального озера и дворца Фештетич.",
    mapAddress: "Хевиз, ул. Ракоци 7",
    mapCta: "Открыть в Google Maps",
  },
  footer: {
    about:
      "Премиальные экскурсии по Венгрии и тщательно организованные путешествия. Каждая деталь для вас — вам остаётся только наслаждаться.",
    menu: "Меню",
    contact: "Контакты",
    addr: "Хевиз, Венгрия",
    rights: "Все права защищены.",
    legal: ["Конфиденциальность", "Условия", "Cookie-уведомление"],
    links: [
      { href: "#fooldal", label: "Главная" },
      { href: "#kirandulasok", label: "Экскурсии" },
      { href: "#transzfer", label: "Трансфер" },
      { href: "#rolunk", label: "О нас" },
      { href: "#velemenyek", label: "Отзывы" },
      { href: "#kapcsolat", label: "Контакты" },
    ],
  },
  toast: {
    callback: {
      title: "Запрос на обратный звонок принят",
      desc: "Скоро перезвоним — пока что можете изучить детали.",
    },
  },
};

export const ICONS = { WHY_ICONS };
export const TRANSLATIONS = { hu: HU, ru: RU };
